<template>
  <div class="laya-course-list">

    <div class="container-fluid">

      <div class="row">
        <div class="col">
          <h3 v-show="filtered.length === 0" class="text-center text-muted">
            Keine Kurse gefunden
          </h3>
        </div>
      </div>

      <ul>
        <li v-for="(courses, category) in coursesByCategory" v-if="filtered.length > 0"
            :key="category" style="margin-bottom: 1.5em">
          <h4>{{ category }}</h4>
          <ul>
            <li v-for="course in courses"
                :key="course.language+'-'+course.category+'-'+course.name" style="margin-bottom: 0.75em">
              <router-link
                  :to="'/courses/'+course.id+'/1'"
                  class="text-dark px-2 py-1 d-inline-block text-center">
                <i class="fas fa-arrow-right"></i>
                {{ course.name }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "laya-course-list",
  data() {
    return {
    };
  },
  props: {
    courses: Array,
    filter: String,
  },
  computed: {
    filtered() {
      if (!this.filter) return this.courses

      const filterByCourseName = new RegExp(this.filter, "i")
      return this.courses.filter(course => filterByCourseName.test(course.name))
    },
    coursesByCategory() {
      const obj = {}
      this.filtered.forEach(course => {
        obj[course.category] = obj.hasOwnProperty(course.category) ? [ ...obj[course.category], course ] : [ course ]
      })
      return obj;
    }
  }
}
</script>

<style scoped>
*:focus {
  outline-offset: 5px;
  outline: 2px dashed deepskyblue;
}

ul {
  list-style-type: none;
}

.header {
  border-bottom: 2px solid black;
}

.course {
  border-bottom: 1px dashed black;
}

.course > div {
  font-size: 120%;
}
</style>
